import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
interface OrderBumpSectionProps {
  embedded?: boolean;
}
export function OrderBumpSection({
  embedded = false
}: OrderBumpSectionProps) {
  const [checked, setChecked] = useState(false);
  const content = <motion.div initial={{
    opacity: 0,
    y: 15
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-60px'
  }} transition={{
    duration: 0.5
  }} onClick={() => setChecked(!checked)} className="relative rounded-2xl p-6 sm:p-8 cursor-pointer transition-all duration-300 max-w-3xl mx-auto" style={{
    backgroundColor: checked ? 'rgba(197, 160, 89, 0.06)' : '#080808',
    border: '2.5px dashed #C5A059',
    boxShadow: checked ? '0 0 30px rgba(197, 160, 89, 0.12)' : 'none'
  }} data-id="element-145">
      {/* Exclusive Offer badge */}
      <motion.div animate={{
      boxShadow: ['0 0 8px rgba(0, 242, 255, 0)', '0 0 14px rgba(0, 242, 255, 0.5)', '0 0 8px rgba(0, 242, 255, 0)']
    }} transition={{
      duration: 2,
      repeat: Infinity,
      ease: 'easeInOut'
    }} className="absolute -top-3 right-4 sm:right-6 px-4 py-1 rounded-full text-xs font-bold uppercase tracking-widest z-10" style={{
      backgroundColor: '#00F2FF',
      color: '#080808',
      fontFamily: "'Space Grotesk', sans-serif"
    }} data-id="element-146">
        Exclusive Offer
      </motion.div>

      {/* 2-column layout: Image (30%) | Content (70%) */}
      <div className="flex flex-col sm:flex-row items-center gap-6 sm:gap-8" data-id="element-147">
        {/* Left Side — Product Image (30%) */}
        <div className="w-full sm:w-[30%] flex-shrink-0 flex justify-center" data-id="element-148">
          <div className="relative w-40 sm:w-full max-w-[200px]" data-id="element-149">
            <div className="absolute inset-0 rounded-xl blur-[30px] opacity-30 pointer-events-none" style={{
            background: 'radial-gradient(ellipse at center, rgba(0, 242, 255, 0.4), transparent 70%)'
          }} data-id="element-150" />
            <img src="https://cdn.magicpatterns.com/uploads/pYd4w6x8p293LA6RFuQ71D/ODER_BUMP.png" alt="24-Hour Inquiry Removal Script" className="relative w-full h-auto rounded-xl object-cover" style={{
            boxShadow: '0 4px 30px rgba(0, 242, 255, 0.18), 0 0 12px rgba(0, 242, 255, 0.1)'
          }} data-id="element-151" />
          </div>
        </div>

        {/* Right Side — Checkbox + Content (70%) */}
        <div className="flex-1 w-full sm:w-[70%]" data-id="element-152">
          <div className="flex items-start gap-4" data-id="element-153">
            {/* Large Gold Checkbox */}
            <div className="flex-shrink-0 mt-0.5 w-10 h-10 sm:w-11 sm:h-11 rounded-lg border-[3px] flex items-center justify-center transition-all duration-200" style={{
            borderColor: checked ? '#C5A059' : '#666',
            backgroundColor: checked ? '#C5A059' : 'transparent',
            boxShadow: checked ? '0 0 15px rgba(197, 160, 89, 0.3)' : 'none'
          }} data-id="element-154">
              {checked && <Check className="w-6 h-6 sm:w-7 sm:h-7 text-black" strokeWidth={3} data-id="element-155" />}
            </div>

            {/* Text Content */}
            <div className="flex-1 min-w-0 text-left" data-id="element-156">
              <h3 className="text-lg sm:text-xl font-bold leading-snug mb-3" style={{
              color: '#C5A059',
              fontFamily: "'Space Grotesk', sans-serif"
            }} data-id="element-157">
                YES! Add the 24-Hour Inquiry Removal Script for only{' '}
                <span className="text-white" data-id="element-158">$17</span>{' '}
                <span className="text-sm font-semibold text-gray-400 line-through" data-id="element-159">
                  $97
                </span>{' '}
                <span className="inline-block ml-1 px-2 py-0.5 rounded text-xs font-bold uppercase" style={{
                backgroundColor: 'rgba(0, 242, 255, 0.15)',
                color: '#00F2FF'
              }} data-id="element-160">
                  90% OFF
                </span>
              </h3>
              <p className="text-gray-300 text-sm sm:text-base leading-relaxed" data-id="element-161">
                Inquiries stay on your report for 2 years. Use my private
                internal bank script to force bureaus to delete hard inquiries
                in as little as <strong className="text-white" data-id="element-162">24 hours</strong>
                . Regular price{' '}
                <span className="line-through text-gray-500" data-id="element-163">$97</span>, yours
                today for just <strong className="text-white" data-id="element-164">$17</strong>.
              </p>
            </div>
          </div>
        </div>
      </div>
    </motion.div>;
  // When embedded, render without the outer section wrapper
  if (embedded) {
    return content;
  }
  return <section className="py-12 px-4" style={{
    backgroundColor: '#080808'
  }} data-id="element-165">
      {content}
    </section>;
}